<div class="detail-page-card">
    @if (listConfig) {
        <generic-list-manager [config]="listConfig"></generic-list-manager>
    }
</div>
